/* eslint-disable camelcase */
/* eslint-disable indent */
import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';

import api from '@/services/api';
import Hero from '@/components/Hero';
import { Container } from '@/styles/pages/post';
import Iframe from '@/components/Iframe';
import Author from '@/components/Author';
import Date from '@/components/Date';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Head from 'next/head';
import parse from 'html-react-parser';
import NotFound from '@/pages/404';
import Loading from '@/components/Loading';
import { ContainerPost } from '@/styles/pages/blog/';

import Link from 'next/link';
import Image from 'next/image';
import { Section, Wrapper } from '@/styles/pages';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import PostModel from '@/models/post';
import SideNav from '@/components/SideNav';
import ActiveField from '@/components/ActiveCampaignFormNew/ActiveField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

interface PostProps {
  post: any;
  preview?: boolean;
  post_id?: string | number;
  previewData?: Record<string, unknown>;
  posts: PostModel[];
}

const Post: React.FC<PostProps> = ({ post, preview, previewData, post_id }) => {
  const router = useRouter();

  const [loadingPost, setLoadingPost] = useState<boolean>(false);
  const [postPreview, setPreview] = useState<any>(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [field, setField] = useState<any>();
  const [success, setSuccess] = useState<any>();
  const sideNavRef = useRef()


  const submit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const { EMAIL } = e.target.elements;

      const payload = {
        contact: {
          email: EMAIL.value,
        },
        tag: 369
      };

      await fetch('/api/activecampaign/contacts/', {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      setLoading(false);
      setSuccess(true)
      e.target.reset()
    } catch (e) {
      setLoading(false);
      console.log(e)
    }
  };

  const category = useMemo(() => {
    if (post) {
      if (preview) {
        return postPreview?._embedded?.['wp:term'][0][0];
      }

      return post?._embedded?.['wp:term'][0][0];
    }
    return null;
  }, [post, postPreview, preview]);

  useEffect(() => {
    const getPosts = async () => {
      try {
        const { data } = await api.get('/posts', {
          params: {
            _embed: 0,
            categories: category.id
          }
        });

        setPosts(data.filter((item) => item.id !== post.id));
      } catch (e) {
        console.log(e);
      }
    };

    getPosts();
  }, [category]);

  useEffect(() => {
    const getField = async (id) => {
      try {
        const { data } = await axios.get(`/api/activecampaign/fields/${id}`);
        setField({ ...data, field: { ...data.field, isrequired: "1" } })
      } catch (e) {
        console.log(e)
      }
    };

    getField(51)
  }, [])


  const yoastTags = useMemo(() => {
    if (!preview && post) {
      const tags = post?.yoast_head.replace(
        /blog.api.cloudez.io(?!\/wp-content)/g,
        'cloudez.io/br/blog'
      );

      return parse(tags);
    }

    return null;
  }, [post, preview]);

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const getPost = async (id) => {
      setLoadingPost(true);

      const auth = await JSON.parse(localStorage.getItem('@cloudez-main/auth'));

      if (!auth) {
        return router.push(`/login?to=/${post_id}`);
      }

      const { data } = await api.get(
        `/posts/${id.toString()}/${previewData.revision ? 'revisions' : ''}`,
        {
          params: {
            _embed: 0,
            preview: !previewData.revision ? preview : null
          },
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        }
      );

      setPreview(previewData.revision ? data[0] : data);
      setLoadingPost(false);
    };

    if (preview) {
      getPost(post_id);
    }
  }, [preview, previewData]);

  if (router.isFallback || loadingPost) {
    return <Loading />;
  }
  if (!post && !postPreview && !loadingPost) {
    return <NotFound />;
  }

  useEffect(() => {
    const sidenavWrapper = document.getElementById('sidenavWrapper');

    const observer = new IntersectionObserver((entities) => {
      const target = entities[0];
      const rect = sidenavWrapper.getBoundingClientRect();

      if (target.isIntersecting && sideNavRef.current) {
        sidenavWrapper.style.position = "absolute"
        sidenavWrapper.style.top = `${rect.top + window.scrollY}px`
      } else {
        sidenavWrapper.style.position = "fixed"
        sidenavWrapper.style.top = `144px`
      }
    });

    if (sideNavRef.current) {
      observer.observe(sideNavRef.current);
    }

    return () => sideNavRef.current && observer.unobserve(sideNavRef.current)
  }, []);

  if (preview) {
    return (
      <>
        <Hero>
          <div className="category">{category?.name}</div>
          <div className="title">{postPreview?.title?.rendered}</div>
        </Hero>

        <Author author={postPreview?._embedded?.author[0]} />

        <Container>
          <Iframe>{postPreview?.content?.rendered}</Iframe>
        </Container>
      </>
    );
  }

  return (
    <>
      <Head>{yoastTags}</Head>
      <SideNav category={category.id} />
      <Author author={post?._embedded?.author[0]} />
      <ContainerPost>
        <div className="container-results_post">
          <div className="steps-result_post">
            <a style={{ marginRight: '7px' }} href="/br/blog">
              <Image
                priority
                src="/home.png"
                width={13}
                height={13}
                alt="home"
              />
            </a>
            <Image
              priority
              src="/arrow-right.png"
              width={8}
              height={16}
              alt="arrow"
            />
            <a
              style={{ marginLeft: '0.5rem' }}
              href={`/br/blog/categoria/${post._embedded?.['wp:term'][0][0]?.slug}`}
            >
              <div style={{ marginRight: '0.5rem' }}>{category.name}</div>
            </a>
            <Image
              priority
              src="/arrow-right.png"
              width={8}
              height={16}
              alt="arrow"
            />
            <div
              style={{ marginLeft: '0.5rem' }}
              className="title"
              dangerouslySetInnerHTML={{
                __html: post?.title?.rendered
              }}
            />
          </div>

          <div className="title-search_post">
            <h1>{category.name}</h1>
          </div>

          <div
            className="title-two"
            dangerouslySetInnerHTML={{
              __html: post?.title?.rendered
            }}
          />
          <Date date={post?.date} />
        </div>
      </ContainerPost>

      <Container>
        <Iframe>{post?.content?.rendered}</Iframe>
      </Container>
      <div ref={sideNavRef}>
        <Section>

          <div className="text" style={{
            padding: 85
          }}>
            {success ? (
              <>
                <p><span style={{
                  color: '#FCFF7C',
                  fontSize: 32
                }}>Obrigado!</span> Enviamos a confirmação da inscrição para o seu e-mail.</p>
                <span >Agradecemos sua inscrição e esperamos que você aproveite nossos conteúdos!</span>
              </>
            ) : <>
              <h1>Conteúdos para <span style={{ color: '#FCFF7C' }}>destacar</span> seu negócio no Ecossistema Digital direto no email</h1>
              <form onSubmit={submit}>
                <ActiveField field={{
                  field: {
                    isDefault: true,
                    title: 'E-mail',
                    type: 'text',
                    perstag: 'EMAIL',
                    isrequired: '1'
                  }
                }} />
                {field && <ActiveField field={field} />}
                <button disabled={loading} type='submit'>{loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Assinar newsletter'}</button>
              </form>
            </>}
          </div>

          <div className="image" style={{
            marginTop: -70
          }}>
            <Image
              priority
              width={585}
              height={530}
              src="/beardman.png"
            />
          </div>

        </Section>

        <Wrapper>
          <div className="section-posts" >
            <h1 style={{ fontSize: '2rem' }} >Posts recomendados</h1>
            <div className="post" >
              {posts.slice(0, 3).map((post) => {
                let excerptTwoCategory = post.excerpt.rendered;
                if (excerptTwoCategory.length > 134) {
                  excerptTwoCategory = `${excerptTwoCategory.substring(
                    0,
                    134
                  )}...`;
                }
                let titleTwoCategory = post.title.rendered;
                if (titleTwoCategory.length > 50) {
                  titleTwoCategory = `${titleTwoCategory.substring(
                    0,
                    50
                  )}...`;
                }

                return (
                  <div className="cardblog" key={post.slug}>
                    <a href={post.slug}>
                      <Image
                        priority
                        src={
                          post._embedded?.['wp:featuredmedia'][0]?.source_url
                        }
                        width="330px"
                        height="271px"
                        alt={
                          post._embedded?.['wp:featuredmedia'][0]?.alt_text
                        }
                      />
                    </a>
                    <div className="card_items">
                      <h3
                        style={{
                          fontSize: '0.70rem',
                          fontWeight: 'bold',
                          fontFamily: 'Montserrat',
                          marginTop: '-0.4rem'
                        }}
                      >
                        <Link
                          href={`/blog/categoria/${post._embedded?.['wp:term'][0][0]?.slug}`}
                        >
                          {post._embedded?.['wp:term'][0][0]?.name}
                        </Link>
                      </h3>

                      <a href={post.slug}>
                        <h2
                          style={{
                            fontWeight: 'bold',
                            fontFamily: 'Montserrat'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: titleTwoCategory
                          }}
                        />
                        <p
                          style={{
                            fontFamily: 'Montserrat',
                            lineHeight: '1rem'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: excerptTwoCategory
                          }}
                        />
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Wrapper></div>
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await api.get('/posts');

  const paths = data.map((post) => ({
    params: {
      id: post.slug
    },
    locale: 'br'
  }));

  return {
    paths,
    fallback: true
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const {
    params: { id },
    preview,
    previewData,
    locale
  } = context;

  if (locale !== 'br') {
    return {
      notFound: true
    };
  }

  if (!preview) {
    const { data } = await api.get('/posts/', {
      params: {
        slug: id,
        _embed: 0
      }
    });

    const post = data[0] || null;
    return {
      props: {
        ...(await serverSideTranslations(locale.toString())),
        post
      },
      revalidate: 60
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(locale.toString())),
      post_id: id,
      preview: preview || false,
      previewData: previewData || null
    },
    revalidate: 60
  };
};

export default Post;
